import { isNativeApp } from "./platform";

/**
 * Native only: open an external URL in the system browser
 * (SFSafariViewController / Chrome Custom Tab) instead of navigating the app
 * WebView away from itself. No-op on web — web callers keep window.open. Only
 * pass genuinely external (cross-origin) URLs; in-app links should stay in the
 * WebView / router.
 */
export async function openExternalUrl(href: string): Promise<void> {
  if (!isNativeApp()) return;
  const { Browser } = await import("@capacitor/browser");
  await Browser.open({ url: href });
}
